var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPopupDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.1666 8L15.5041 17.4552C15.364 18.2522 14.6718 18.8333 13.8627 18.8333H7.1372C6.32808 18.8333 5.63584 18.2522 5.49572 17.4552L3.83325 8",
    stroke: "black",
    strokeWidth: 0.833333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18 5.49984H13.3125M13.3125 5.49984V3.83317C13.3125 2.9127 12.5663 2.1665 11.6458 2.1665H9.35417C8.43369 2.1665 7.6875 2.9127 7.6875 3.83317V5.49984M13.3125 5.49984H7.6875M3 5.49984H7.6875",
    stroke: "black",
    strokeWidth: 0.833333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupDelete);
export default __webpack_public_path__ + "static/media/PopupDelete.a8ff90077c0da7484e8d429c91ca88ac.svg";
export { ForwardRef as ReactComponent };